import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const links = [
  { label: 'Ürün', to: '/ozellikler' },
  { label: 'Çözümler', to: '/canli-hayvan-stok-takip-programi' },
  { label: 'Kullanım Rehberi', to: '/kullanim-rehberi' },
  { label: 'Fiyatlandırma', to: '/fiyatlandirma' },
  { label: 'Sık Sorulanlar', to: '/sss' },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const demoHref = location.pathname === '/' ? '#demo' : '/#demo';

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/80 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2" onClick={() => setOpen(false)}>
          <span className="grid h-9 w-9 place-items-center rounded-xl bg-primary-600 shadow-sm"><i className="ri-leaf-line text-xl text-white" /></span>
          <span className="font-heading text-xl font-extrabold tracking-tight text-foreground-950">Ciftlik<span className="text-primary-600">Web</span></span>
        </Link>
        <nav className="hidden items-center gap-7 md:flex">
          {links.map((item) => <Link key={item.to} to={item.to} className="text-sm font-semibold text-foreground-700 transition hover:text-primary-600">{item.label}</Link>)}
          <a href={demoHref} className="rounded-xl bg-primary-600 px-4 py-2.5 text-sm font-bold text-white shadow-sm transition hover:bg-primary-700">Demo talep et <i className="ri-arrow-right-line ml-1" /></a>
        </nav>
        <button className="grid h-10 w-10 place-items-center rounded-lg text-foreground-800 md:hidden" onClick={() => setOpen(!open)} aria-label="Menüyü aç"><i className={open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'} /></button>
      </div>
      {open && <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
        <div className="mx-auto flex max-w-7xl flex-col gap-1">
          {links.map((item) => <Link key={item.to} to={item.to} onClick={() => setOpen(false)} className="rounded-lg px-3 py-3 text-sm font-semibold text-foreground-700 hover:bg-primary-50">{item.label}</Link>)}
          <a href={demoHref} onClick={() => setOpen(false)} className="mt-2 rounded-xl bg-primary-600 px-4 py-3 text-center text-sm font-bold text-white">Demo talep et</a>
        </div>
      </div>}
    </header>
  );
}
